var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBlueUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.306 6.829A1 1 0 006.72 5.414L2.478 1.172a1 1 0 00-1.415 1.414L5.306 6.83z",
  fill: "#005FF9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.694 6.829A1 1 0 015.28 5.414l4.243-4.242a1 1 0 011.414 1.414L6.694 6.83z",
  fill: "#005FF9"
})));
export { SvgArrowBlueUp as ReactComponent };